const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'registered_trikos']
}

export default config
